const state = {
    notes: [],
    scratch: {

    }
};

const getters = {
    notes: state => {
        return state.notes;
    },
    scratch: (state) => (applicationId) => {
      return _.get(state.scratch, applicationId, '')
    }
};

const mutations = {
    saveNote(state, notes) {
        state.notes.unshift(notes);
    },
    saveNotes(state, notes) {
        state.notes = notes;
    },
    saveScratch(state, scratch) {
        Vue.set(state.scratch, scratch.applicationId, scratch.note)
    },
    deleteScratch(state, applicationId) {
        delete state.scratch[applicationId]
    }
};

const actions = {
    saveNote(context, notes) {
        context.commit("saveNote", notes);
    },
    saveNotes(context, notes) {
        context.commit("saveNotes", notes);
    },
    saveScratch(context, scratch) {
        context.commit("saveScratch", scratch)
    },
    deleteScratch(context, applicationId) {
        context.commit('deleteScratch', applicationId)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
